module.exports = __webpack_public_path__ + "static/media/logo_urgently_verticle.823bd98c.svg";